import Button from "components/buttons/Button/Button";
import type { FunctionComponent} from "react";
import { useEffect, useState } from "react";
import { generatePath } from "react-router-dom";

import Sidebar from "~/components/Sidebar/Sidebar";
import { appRoutes } from "~/constants/appRoutes.ts";
import { useAllClients } from "~/modules/client/api/client/clientQueries.ts";
import type { Client } from "~/modules/client/api/client/clientTypes.ts";
import CreateCompanyForm from "~/modules/client/components/forms/CreateCompanyForm";

type ClientViewSidebarProps = {
	isOpen: boolean;
	setOpen: (open: boolean) => void;
};

const CreateCompanySidebar: FunctionComponent<ClientViewSidebarProps> = ({ isOpen, setOpen }) => {
	const [newCompanyId, setNewCompanyId] = useState<string | null>(null);
	const [newClientData, setNewClientData] = useState<Client | null>(null);
	/*	const [showNewProjectForm, setShowNewProjectForm] = useState(false);
	const [setShowContactPersonForm, setSetShowContactPersonForm] = useState(false);*/

	const { data: allClientsData } = useAllClients();

	useEffect(() => {
		if (newCompanyId && allClientsData) {
			const newClient = allClientsData?.find((client) => client.companyId === newCompanyId);
			if (newClient) {
				setNewClientData(newClient);
			}
		}
	}, [newCompanyId, allClientsData]);

	useEffect(() => {
		if (!isOpen) {
			setNewCompanyId(null);
			setNewClientData(null);
		}
	}, [isOpen]);

	return (
		<Sidebar closeOnOutsideClick={false} open={isOpen} setOpen={() => setOpen(!isOpen)}>
			{!newCompanyId && !newClientData && (
				<CreateCompanyForm onSuccess={setNewCompanyId} onCancel={() => setOpen(false)} />
			)}
			{newClientData && (
				<div className="px-8 py-6">
					<div className="mb-4 text-center text-xl font-bold text-gray-800">
						Neuer Kunde &quot;{newClientData.displayName}&quot; erstellt
					</div>
					<div className="mb-4 text-center text-gray-800">Was möchtest Du als nächstes tun?</div>
					<div className="flex flex-col space-y-4">
						{/*		<Button className="justify-center" onClick={() => setShowNewProjectForm(true)}>Projekt für den
						Kunden
						erstellen</Button>
					<Button className="justify-center" onClick={() => setShowNewProjectForm(true)}>Kontakt für den
						Kunden
						erstellen</Button>*/}
						<Button
							className="justify-center"
							to={generatePath(appRoutes.client("").path, { clientId: newClientData.id })}
						>
							Kundenseite öffnen
						</Button>
					</div>
				</div>
			)}
		</Sidebar>
	);
};

export default CreateCompanySidebar;
